export const currencyList = [
  { title: "USD", symbol: "$" },
  { title: "Rupees", symbol: "₹" },
];
